import styled from 'styled-components';

import colors from '@constants/colors';

export const Container = styled.div`
  position: relative;
  .form {
    border-right: 1px solid ${colors.GRAY_BRIGHT_2};
  }
`;
